'use client';

import initDatadog from 'utils/initDatadog';

initDatadog();

export const DatadogInit = () => {
  return null;
};
